<template>
  <button
    type="button"
    class="ui-navigation-button"
    :class="{ active, disabled }"
    :disabled="disabled"
    :aria-current="active ? 'page' : null"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <i v-if="icon" :class="icon"></i>
    <span><slot /></span>
  </button>
</template>

<script>
export default {
  name: 'UiNavigationButton',
  inheritAttrs: false,
  props: {
    icon: { type: [String, Array, Object], default: '' },
    active: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false }
  }
}
</script>

<style lang="scss">
.ui-navigation-button {
  display: flex;
  align-items: center;
  width: 100%;
  height: 56px;
  margin: 0;
  padding: 0 var(--ui-space-lg);
  border: 0;
  border-radius: 0;
  color: var(--ui-text-primary);
  background: transparent;
  box-shadow: none;
  font-size: var(--ui-font-size-navigation);
  font-weight: var(--ui-font-weight-medium);
  text-align: left;
  cursor: pointer;
  transition: color var(--ui-duration-fast) ease,
    background-color var(--ui-duration-fast) ease,
    box-shadow var(--ui-duration-fast) ease;
}

.ui-navigation-button > i {
  width: 20px;
  margin-right: var(--ui-space-sm);
  color: inherit;
  font-size: var(--ui-icon-size-medium);
  font-weight: 400;
  line-height: 1;
  text-align: center;
}

@media (hover: hover) and (pointer: fine) {
  .ui-navigation-button:not(.active):not(:disabled):hover {
    color: var(--ui-text-primary);
    background: var(--ui-bg-panel-elevated);
  }
}

.ui-navigation-button.active {
  color: var(--ui-text-primary);
  background: rgba(var(--ui-color-primary-rgb), .1);
  box-shadow: inset -2px 0 var(--ui-color-primary);
}

.ui-navigation-button.active > i {
  color: inherit;
}

.ui-navigation-button:disabled {
  opacity: .4;
  cursor: not-allowed;
}
</style>
